import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Check if any modal is currently open
    const isModalOpen =
      document.querySelector('.mantine-Modal-root') ||
      document.querySelector('[data-mantine-modal]') ||
      document.querySelector('.mantine-Modal-overlay');

    // Only scroll to top if no modal is open
    if (!isModalOpen) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
